const formatDate = (date: Date): string =>
  date.toLocaleDateString('sv-SE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

export default formatDate;
